<template>
  <div v-show="rendered" class="MagazineEmbedding" v-html="htmlContent"></div>
</template>

<script>
export default {
  props: {
    content: {
      type: String,
      required: true,
    },
  },
  data: () => ({
    rendered: false,
  }),
  computed: {
    htmlContent() {
      return this.content.split('<script')[0]
    },
  },
  mounted() {
    const regex = /.*?<script.*?src="([^"]+)"/
    const exec = regex.exec(this.content)
    if (exec) {
      const src =
        exec[1].substring(0, 2) === '//' ? `https:${exec[1]}` : exec[1]
      let jsScript = document.createElement('script')
      jsScript.setAttribute('src', src)
      jsScript.setAttribute('async', '')
      jsScript.setAttribute('defer', '')
      document.getElementsByTagName('head')[0].appendChild(jsScript)
      jsScript.addEventListener(
        'load',
        () => {
          this.$nextTick(() => {
            this.rendered = true
            if (src.includes('instagram')) {
              window.instgrm.Embeds.process()
            }
          })
        },
        false,
      )
    }
  },
}
</script>

<style lang="postcss">
.MagazineEmbedding {
  max-width: 450px;
  margin-bottom: var(--spacing-16);

  @media (max-width: 490px) {
    margin-bottom: var(--spacing-8);
  }
}
</style>
